import React, { useState, useEffect, useCallback, useContext } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import moment from "moment";
import { TostMsg } from "../../../../../App";
import { getWFHDetails } from "../WfhSerevice";
const defaultImage = "/images/placeholder_profile.png";

const TodaysWFH = () => {
  const [WFHData, setWFHData] = useState([]);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [masterSystemAlertData, setMasterSystemAlertData] = useState([]);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const [noData, setNoData] = useState([]);
  const toster = useContext(TostMsg);
  const [Isloading, setIsloading] = useState(false);

  useEffect(() => {
    getWFHData();
    GetMasterSystemAlertList("Today_Wfh_Tip", 1);
    GetMasterSystemAlertList("WFH_loggedToday", 2);
  }, []);

  async function getWFHData() {
     let loggedInEmpId = userDetails?.OverseerId;
    if (loggedInEmpId != 0 ?? loggedInEmpId != null) {
      loggedInEmpId = userDetails?.OverseerId;
    } else {
      loggedInEmpId = userDetails?.EmpId;
    }
    setIsloading(true);
    let FilterendOfTheDay = new Date();
    FilterendOfTheDay?.setUTCHours(23, 59, 59, 999);
    const FilterEndDate = FilterendOfTheDay?.toISOString();
    const param = {
      OrgId: userDetails?.OrgId,
      LoggedInEmpId: loggedInEmpId,//userDetails?.EmpId,
      WFHid: 0,
      EmpId: 0,//userDetails?.EmpId,
      HierarchyTypeId: 3,
      FilterStartDate: new Date(),
      FilterEndDate: FilterEndDate,
      pageNumber: 1,
      pageSize: 10000,
      WFHcategory: "U",
    };
    try {
      const responce = await getWFHDetails(param);
      setIsloading(false);
      setWFHData(responce?.Data);
    } catch {
      setIsloading(false);
    }
  }
  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, []);

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 1) {
        setMasterSystemAlertData(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        setNoData(msg?.Desc);
      }
    });
  }, []);

  return (
    <div>
      <div className="row sidecarddd">
        <div>
          <div className="col-xl-12 position-relation">
            <div className="">
              <div className="card-body todays-leave position-relative">
                <h5>
                  Today's WFH
                   <div className="info-tooltip-area2">
                     <img
                    src="/images/org-img/leave/info.svg"
                    className="infoimg"/>


                  <div className="info-tooltip-content info-area">
                    <div className="purchase-tooltip-content">{masterSystemAlertData}</div>
                  </div>
                   </div>
                
                </h5>
                <div className="set-scroll">
                  {WFHData?.map((el) => (
                    <div className="today-leave-list">
                      <img
                        alt={el.FullName}
                        src={el.ProfileImage || defaultImage}
                        className="w-100"
                        onError={handleImageError}
                        width="32"
                        style={{ opacity: "1" }}
                      />
                      <div className="inner">
                        <h6>{el?.EmployeeName}</h6>
                        <div className="content">
                          <p>
                            <b>Start date:</b>{" "}
                            {moment(el?.StartDate)?.format("MMM Do YYYY")}
                          </p>
                          <p>
                            <b>End date:</b>{" "}
                            {moment(el?.EndDate)?.format("MMM Do YYYY")}
                          </p>
                        </div>
                        <p className="status-btn">
                          <i className="fa fa-clock-o" aria-hidden="true"></i>{" "}
                          {el?.WFHStatusName}
                        </p>
                      </div>
                    </div>
                  ))}
                  {WFHData?.length == 0 && (
                    <div className="no-datadiv">
                      <img src="/images/org-img/leave/no-data.png" />
                      <p>{noData}</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-xl-12 position-relation">
        <div
          className="leave-ad-design"
          data-background="assets/img/illustrations/cards/birthday-bg.svg"
        >
          <div className="card-body">
            <div>
              <div className="birthday-avatar text-center">
               <svg viewBox="0 0 160 90" fill="none" xmlns="http://www.w3.org/2000/svg" width="160" height="90">
  <rect x="20" y="40" width="30" height="44" rx="4" fill="#671cc9" opacity=".85"></rect>
  <rect x="22" y="42" width="26" height="2" rx="1" fill="#fff" opacity=".4"></rect>
  <rect x="22" y="47" width="20" height="2" rx="1" fill="#fff" opacity=".3"></rect>

  <rect x="52" y="30" width="30" height="54" rx="4" fill="#ec4119" opacity=".85"></rect>
  <rect x="54" y="32" width="26" height="2" rx="1" fill="#fff" opacity=".4"></rect>
  <rect x="54" y="37" width="18" height="2" rx="1" fill="#fff" opacity=".3"></rect>

  <rect x="84" y="20" width="30" height="64" rx="4" fill="#26a69a" opacity=".85"></rect>
  <rect x="86" y="22" width="26" height="2" rx="1" fill="#fff" opacity=".4"></rect>
  <rect x="86" y="27" width="22" height="2" rx="1" fill="#fff" opacity=".3"></rect>

  <circle cx="132" cy="42" r="12" fill="#f7c5a8"></circle>
  <path d="M126 38 Q128 32 132 32 Q136 32 138 38" fill="#2d1a0e"></path>
  <circle cx="129" cy="42" r="1.5" fill="#2d1a0e"></circle>
  <circle cx="135" cy="42" r="1.5" fill="#2d1a0e"></circle>
  <path d="M129 47 Q132 50 135 47" stroke="#2d1a0e" stroke-width="1" stroke-linecap="round" fill="none"></path>

  <rect x="122" y="54" width="20" height="24" rx="8" fill="#671cc9"></rect>
  <path d="M122 78 Q114 82 108 78" stroke="#f7c5a8" stroke-width="6" stroke-linecap="round"></path>
  <path d="M142 78 Q150 82 152 76" stroke="#f7c5a8" stroke-width="6" stroke-linecap="round"></path>

  <rect x="108" y="62" width="18" height="13" rx="3" fill="#ec4119" opacity=".9"></rect>
  <rect x="110" y="64" width="14" height="1.5" rx=".75" fill="#fff" opacity=".6"></rect>
  <rect x="110" y="68" width="10" height="1.5" rx=".75" fill="#fff" opacity=".4"></rect>

  <text x="96" y="18" font-size="10" fill="#ec4119" opacity=".8">✦</text>
  <text x="148" y="28" font-size="8" fill="#671cc9" opacity=".7">✦</text>
  <text x="12" y="36" font-size="7" fill="#26a69a" opacity=".7">✦</text>
</svg>
              </div>
              <div className="birthday-content">
                <Link to="/Policylist">
                  <h4>Review our employee WFH policy</h4>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TodaysWFH;
